import { FC, memo, useEffect, useState } from 'react';
import { PlanCardProps } from './PlanCard.types';
import styles from './PlanCard.module.scss';
import classNames from 'classnames';
import FWDPrice from '../FWDPrice';
import NormalPrice from '../NormalPrice';
import Icon from '@ant-design/icons/lib/components/Icon';
import DiscountIcon from '../../public/icon/greenDiscount.svg';
import { handleRichText } from '@/utils/handleRichText';
const PlanCard = memo((props: any) => {
  const {
    plan_name,
    plan_description,
    annual_benefit_limit_label,
    annual_benefit_limit,
    lifetime_benefit_limit_label,
    lifetime_benefit_limit,
    sumInsured,
    paymentFrequency,
    callout_label,
    qouteLabel,
    shouldShowQuoteLabel,
    originalPrice,
    price,
    code,
    option_code
  } = props?.data;
  const { isDeductible, isSelected, isLoading, isDisable = false } = props;
  const [isLargeCard, setIsLargeCard] = useState(false);

  const benefits: [string | undefined, number][] = [
    [annual_benefit_limit_label, annual_benefit_limit],
    [lifetime_benefit_limit_label, lifetime_benefit_limit]
  ];

  useEffect(() => {
    const planCard = document.getElementById('plan_card');
    planCard && setIsLargeCard(planCard?.offsetWidth > 600);
    window.addEventListener('resize', () => {
      planCard && setIsLargeCard(planCard?.offsetWidth > 600);
    });
  }, []);

  return (
    <div
      className={classNames(styles.plan_card, isSelected && styles.active, isDisable && styles.disable)}
      id="plan_card"
      onClick={() => {
        props.onChange(props.data);
      }}
    >
      {callout_label && <div className={styles.plan_tag}>{callout_label}</div>}
      <div id="plan_price_wrapper" className={classNames(styles.info_wrapper, isLargeCard && styles.flex)}>
        <div className={styles.detail_wrapper}>
          {plan_name && (
            <div className={styles.title_wrapper}>
              <div className={styles.title}>{plan_name}</div>
              {plan_description && (
                <div
                  className={classNames(styles.rich_text, styles.description)}
                  dangerouslySetInnerHTML={{
                    __html: handleRichText(plan_description),
                  }}
                ></div>
              )}
            </div>
          )}
          {!isDeductible && (
            <div className={styles.insured_wrapper}>
              <span className={styles.insured_title}>投保額</span>
              <NormalPrice fontSize={14} price={sumInsured} isDisable={isDisable} />
            </div>
          )}
          {isDeductible &&
            benefits.map(([label, value]) => {
              return (
                label && (
                  <div className={styles.insured_wrapper}>
                    <span className={classNames(styles.insured_title, isLargeCard && styles.block)}>{label}</span>
                    <NormalPrice fontSize={14} price={value} isDisable={isDisable} />
                  </div>
                )
              );
            })}
        </div>

        <div className={styles.price_wrapper}>
          {qouteLabel?.length > 0 && (
            <NormalPrice
              isDisable={isDisable}
              fontSize={12}
              price={originalPrice}
              lineThrough={true}
              showDecimal={true}
            />
          )}
          <FWDPrice
            isDisable={isDisable}
            price={price}
            unit={paymentFrequency === 'MONTHLY' ? '月' : '年'}
            isLoading={isLoading}
          />
        </div>
      </div>

      {shouldShowQuoteLabel && qouteLabel?.length > 0 && (
        <div className={styles.qoute_wrapper}>
          <Icon component={DiscountIcon} size={14} />
          <span className={styles.qoute_label}>{qouteLabel}</span>
        </div>
      )}
    </div>
  );
});
export default PlanCard;
